
export const ROOTURL = import.meta.env.PROD?'https://www.whitemark.co.kr':'http://localhost:4000';
export const APIURL = `${ROOTURL}/api`;
//export const STORAGE_URL = import.meta.env.PROD?'https://www.sparkon.co.kr/storage':'http://localhost:3000/storage';
export const SOCKETIO_URL = import.meta.env.PROD?'https://www.whitemark.co.kr':'http://localhost:4000';



export const race_type_list = [
  {label:'RUN-1',value:1}, 
  {label:'RUN-2 Best',value:2}, 
  {label:'RUN-2 Total',value:3}, 
  // {label:'토너먼트',value:4}, 
]

export const tournament_round =[
  {label:'결승',         round_cnt:2  },
  {label:'준결승(4강)',  round_cnt:4  },
  {label:'8강' ,         round_cnt:8  },
  {label:'16강',         round_cnt:16 },
  {label:'32강',         round_cnt:32 },
  {label:'64강',         round_cnt:64 },
]
export const boardcross_round =[
  {label:'Big final',    round_cnt:2  },
  {label:'Semi final',   round_cnt:4  },
  {label:'16강' ,        round_cnt:8  },
  {label:'32강',         round_cnt:16 },
  {label:'64강',         round_cnt:32 },
  {label:'64강',         round_cnt:64 },
]

export const normal_tournament_selectList = [
  {label:'결승',         round_cnt:2},
  {label:'준결승(4강)',  round_cnt:4},
  {label:'8강' ,         round_cnt:8},
  {label:'16강',         round_cnt:16},
  {label:'32강',         round_cnt:32},
  {label:'64강',         round_cnt:64},
]

export const bordCross_tournament_selectList = [
  {label:'결승',   round_cnt:2},
  {label:'준결승', round_cnt:4},
  {label:'16강',   round_cnt:8},
]

export const seedSet_tournament={
  4:[
    [1,4],
    [3,2],
  ],
  8:[
    [1,8],
    [5,4],
    [3,6],
    [7,2],
  ],
  16:[
    [1,16],
    [9,8],
    [5,12],
    [13,4],
    [3,14],
    [11,6],
    [7,10],
    [15,2],
  ],
  32:[
    [1,32],
    [17,16],
    [9,24],
    [25,8],
    [5,28],
    [21,12],
    [13,20],
    [29,4],
    [3,30],
    [19,14],
    [11,22],
    [27,6],
    [7,26],
    [23,10],
    [15,18],
    [31,2],
  ],
  
}

export const seedSet_boardCross={
  2:[
    [1,2,3,4],
  ],

  4:[
    [1,4,5,8],
    [2,3,6,7],
  ],
  8:[
    [1,8,9,16],
    [4,5,12,13],
    [3,6,11,14],
    [2,7,10,15],
  ], 
}